import { render, staticRenderFns } from "./CDropdownItem.vue?vue&type=template&id=50f29a60&"
import script from "./CDropdownItem.vue?vue&type=script&lang=js&"
export * from "./CDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports